"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Partner = void 0;
const Photo_1 = require("./Photo");
const common_util_1 = require("../util/common-util");
const EsText_1 = require("./EsText");
const CommonDto_1 = require("../dto/CommonDto");
class Partner {
    constructor(description) {
        this.id = 0;
        this.title = "";
        this.subtitle = "";
        this.logo = null;
        this.logoId = 0;
        this.link = "";
        this.order = 0;
        this.description = description;
    }
    get initials() {
        return common_util_1.initials(this.title);
    }
    get hasImage() {
        return this.logo !== null;
    }
    get lqImageUrl() {
        var _a, _b;
        return (_b = (_a = this.logo) === null || _a === void 0 ? void 0 : _a.lq.url) !== null && _b !== void 0 ? _b : "";
    }
    static fromDto(eventPartnerDto) {
        const description = EsText_1.EsText.fromOptionalTextDto(eventPartnerDto.description);
        const partner = new Partner(description);
        partner.id = eventPartnerDto.id;
        partner.title = eventPartnerDto.title;
        if (eventPartnerDto.subtitle) {
            partner.subtitle = eventPartnerDto.subtitle;
        }
        if (eventPartnerDto.logo && eventPartnerDto.logo.type === CommonDto_1.PhotoType.PHOTO) {
            partner.logo = Photo_1.Photo.fromDto(eventPartnerDto.logo);
            partner.logoId = partner.logo.uploadId;
        }
        if (eventPartnerDto.link) {
            partner.link = eventPartnerDto.link;
        }
        partner.order = eventPartnerDto.order;
        return partner;
    }
    toDto() {
        const resultDto = {
            id: this.id,
            title: this.title,
            order: this.order
        };
        if (this.subtitle) {
            resultDto.subtitle = this.subtitle;
        }
        if (this.description.notEmpty) {
            resultDto.description = this.description.toOptionalTextDto();
        }
        if (this.logoId !== 0) {
            resultDto.logo = {
                type: CommonDto_1.PhotoType.ID,
                uploadId: this.logoId
            };
        }
        if (this.link) {
            resultDto.link = this.link;
        }
        return resultDto;
    }
}
exports.Partner = Partner;
